import React from "react";
import { animateScroll as scroll } from "react-scroll";
import { homeHelpMatchItems, homePageHelpMatchItems } from "../../data/data";
import HealthImg from "../../images/health-provider.png";
import { scrollToTop } from "../../utilities/utils";

const HomePageHealthProvider = () => {
  return (
    <div className="pt-[50px] pb-10 md:py-[100px]">
      <div className="container">
        <div className="flex items-start gap-[30px] md:gap-[60px] lg:gap-[78px] flex-wrap lg:flex-nowrap justify-center lg:justify-between">
          <div className="text-center block lg:hidden">
            <span className="text-[26px]">👋🏼</span>
            <h2 className="mb-[30px] text-[26px] -tracking-[0.52px] text-center">
              Find the <span className="text-primary">Healthcare Provider</span>{" "}
              Your Friends and Family Would Recommend.
            </h2>
            {/* <div className="bg-[#D834A0] w-[55px] h-[5px] rounded-[40px] mx-auto"></div> */}
          </div>
          <img
            className="max-w-[500px] lg:max-w-[577px] w-full rounded-[20px] overflow-hidden"
            src={HealthImg}
            alt="Health Img"
            loading="lazy"
          />
          <div className="max-w-full lg:max-w-[625px] w-full pt-3">
            <div className="hidden lg:block">
              <h2 className="mb-[58px] text-[26px] xl:text-[40px] text-start -tracking-[0.52px]">
                👋🏼 Find the{" "}
                <span className="text-primary">Healthcare Provider</span> Your
                Friends and Family Would Recommend.
              </h2>
              {/* <div className="bg-[#D834A0] w-[55px] h-[5px] rounded-[40px] mb-[50px] lg:mb-[32px]"></div> */}
            </div>
            <ul className="w-full">
              {homePageHelpMatchItems.map((item, index) => (
                <li key={`${index}-item`} className="flex gap-5 mb-[30px]">
                  <div
                    style={{ backgroundColor: `${item.bgColor}` }}
                    className="thumbnail w-[60px] h-[60px] rounded-[10px] flex items-center justify-center"
                  >
                    <img src={item.img} alt={item.altImg} loading="lazy" />
                  </div>
                  <div className="detail w-[calc(100%-80px)]">
                    <h5 className="text-base xl:text-lg font-bold text-customGray leading-[160%] xl:mb-3">
                      {item.label}
                    </h5>
                    <p
                      className="text-base xl:text-lg font-normal text-customGray leading-[160%]"
                      dangerouslySetInnerHTML={{ __html: item.detail }}
                    ></p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <button
          className="text-white lg:text-lg text-base font-black leading-[160%] h-full border-none bg-primary w-full p-3 rounded-[10px] mt-[10px] block md:hidden capitalize"
          onClick={scrollToTop}
        >
          get matched now
        </button>
      </div>
    </div>
  );
};

export default HomePageHealthProvider;
